// HomeInfo.js
import "./HomeInfo.css";

const pillars = [
  {
    title: "Certified",
    icon: "/shield-trust.png",
    alt: "Shield Trust",
    body: "AIM Blind and Drapery is an authorized Hunter Douglas local repair center serving the Bay Area Peninsula.",
  },
  {
    title: "Professional",
    icon: "/shirt.png",
    alt: "Shirt",
    body: "We have been in the Hunter Douglas repair industry since 2009, servicing over thousands of clients.",
  },
  {
    title: "Quality",
    icon: "/sparkles.png",
    alt: "Sparkles",
    body: "Specializing in professional window blind repairs, we offer a full range of services to seamlessly restore the beauty and functionality of your blinds.",
  },
];

const HomeInfo = () => {
  return (
    <section className="section section--plain">
      <div className="section__inner">
        <header className="home-info__header">
          <span className="eyebrow">Who we are</span>
          <h2 className="section-title">Certified, Professional, Quality</h2>
        </header>

        <div className="pillar-grid">
          {pillars.map((pillar) => (
            <article className="pillar" key={pillar.title}>
              <img
                src={pillar.icon}
                alt={pillar.alt}
                className="pillar__icon"
                width="70"
                height="70"
              />
              <h3 className="pillar__title">{pillar.title}</h3>
              <p className="pillar__body">{pillar.body}</p>
            </article>
          ))}
        </div>

        <figure className="home-info__figure">
          <img src="/4_vignette.jpg" alt="Vignette" />
        </figure>
      </div>
    </section>
  );
};

export default HomeInfo;
